import type { IconSvgObject } from './types';

const SectionIcon: IconSvgObject = [
  ["path", { d: "M16 6C16 4.34315 14.2091 3 12 3C9.79086 3 8 4.34315 8 6C8 7.65685 9.93845 9 12 9C14.5 9 16 10.3431 16 12C16 13.6569 14.2091 15 12 15C9.79086 15 8 13.6569 8 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 12C16 10.3431 14.2091 9 12 9C9.79086 9 8 10.3431 8 12C8 13.6569 9.93845 15 12 15C14.5 15 16 16.3431 16 18C16 19.6569 14.2091 21 12 21C9.79086 21 8 19.6569 8 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SectionIcon;
